// 本番ビルドや実ユーザープールの認証先をローカルへ切り替えない。
export const localCognitoEndpoint = ({ nodeEnv, stage, endpoint, hostname, poolId, clientId, }) => {
    if (!endpoint)
        return undefined;
    if (nodeEnv !== 'development' ||
        stage !== 'local' ||
        !['localhost', '127.0.0.1'].includes(hostname) ||
        poolId !== 'local_agentpool' ||
        clientId !== 'agentlocalclient' ||
        !['http://localhost:9229', 'http://127.0.0.1:9229'].includes(endpoint)) {
        throw new Error('ローカル認証は専用の開発環境でのみ利用できます');
    }
    return endpoint;
};
